package io.horion.cv.api.usecase

import io.horion.cv.api.datasource.payement.PaymentMethod
import io.horion.cv.api.datasource.payement.PaymentRequest
import io.horion.cv.api.datasource.payement.ServiceType
import io.horion.cv.api.datasource.response.Response
import io.horion.cv.api.datasource.response.SessionsResponse
import io.horion.cv.api.repository.payement.PayRepository
import io.horion.cv.api.utils.TokenRepository
import io.horion.cv.api.utils.TokenRepository.apiWithTokenRetry

class PayUseCase(
    private val apiPay: PayRepository
) {
    suspend fun payement(sessionsUuid: String, amount: Double, phoneNumber: String, method: PaymentMethod): Response {
        val uuid = TokenRepository.getUuidFromToken() ?: return Response(false,"veillez vous connecter")
        val pay = PaymentRequest(
            userUuid = uuid,
            sessionsUuid = sessionsUuid,
            serviceType = ServiceType.CV,
            amount = amount,
            phoneNumber = phoneNumber,
            method = method
        )
        return apiPay.payement(pay)
    }

    suspend fun pollCvStatus(sessionUuid: String): SessionsResponse? {
        return apiWithTokenRetry { token ->
            apiPay.getCvStatus(token,sessionUuid)
        }
    }

    suspend fun downloadCv(url : String) {
        return apiPay.DownloadCv(url)
    }
}